export default __webpack_public_path__ + "static/media/paid-stamp.9e62acc9.png";